export default "__VITE_ASSET__BS1l4kST__"